module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms41e-detail"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS41EC2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.numappl) + " - " + _vm._s(_vm.indexSelected.desc_numappl))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS41EC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.indexSelected.dteappoi)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS41EC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.tab1.detail.codform) + " - " + _vm._s(_vm.detail.tab1.detail.desc_codform))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('detail-tab1', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "detailTab1": _vm.detail.tab1,
      "postHrms41eTab1Save": _vm.postHrms41eTab1Save,
      "indexSelected": _vm.indexSelected,
      "searchIndex": _vm.searchIndex
    }
  }), _vm._v(" "), _c('detail-tab2', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "detailTab2": _vm.detail.tab2,
      "indexSelected": _vm.indexSelected,
      "detailTab2Columns": _vm.detailTab2Columns
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc438042!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms41e/detail.vue
// module id = 3992
// module chunks = 1